import 'lite-youtube-embed';

export default defineNuxtPlugin(() => {});
